import { RouteItem } from 'src/ui/components/Layout/SideBar'

export class DashboardModel {
  public breadcrumbs = {} as RouteItem
  constructor() {}
}
